import clsx from "clsx";
import shape from "../../assets/img/shapes/event-shape-01.webp";


const EventShape01 = ( props:any ) => {

    return (
        <div className={clsx("rmdr-event-shape-01", props.className)}>
            <img src={shape} alt="rmdr-event-shape-01" loading="lazy" width={330} height={65} />
        </div>
    )

}

export default EventShape01;
